import React from "react";

interface AddButtonProps {
  onClick: () => void;
}
const AddButton = ({ onClick }: AddButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="btn btn-soft-primary btn-sm"
    >
      <i className="fas fa-plus"></i>
    </button>
  );
};

export default AddButton;
